import template from './metal-badge.html';

export default angular
  .module('app.holding.dashboard.metals')
  .directive('holdingMetalBadge', holdingMetalBadge)
  .name;

const metals = {
  Gold: {
    element: 'Au',
  },
  Silver: {
    element: 'Ag',
  },
  Platinum: {
    element: 'Pt',
  },
  Palladium: {
    element: 'Pd',
  },
};

function holdingMetalBadge() {
  'ngInject';

  return {
    link,
    replace: true,
    restrict: 'E',
    template,
    scope: {
      metal: '=',
    },
  };

  function link($scope) {
    $scope.getClass = () => {
      const metal = metals[$scope.metal];
      return metal ? metal.element.toLowerCase() : metal;
    };

    $scope.getElement = () => {
      const metal = metals[$scope.metal];
      return metal ? metal.element : metal;
    };
  }
}



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/metals/directives/metal-badge/metal-badge.js